import React from "react";
import UserReferrerService from "../../../services/management/UserReferrerService";
import UserInviteFormState, { UserInviteFormProps } from "./UserInviteForm.models";
import './UserInviteForm.scss';
import NotifyContext from "../../../contexts/NotifyContext";
import QrInviteFriendsCode from "./QrInviteFriendsCode";

export default class UserInviteForm extends React.PureComponent<UserInviteFormProps, UserInviteFormState> {
    userReferrerService: UserReferrerService;
    static contextType = NotifyContext;
    qrCodeGenerate: React.RefObject<QrInviteFriendsCode>;

    constructor(props: any) {
        super(props);
        this.qrCodeGenerate = React.createRef();
        this.userReferrerService = new UserReferrerService();
        this.state = { entity: { phoneNumber: '', fullName: '' }};
    }

    sendMessage = () => {
        let self = this;
        let state = self.state;
        
        if (state.entity.fullName === '' || state.entity.phoneNumber === '')
            return self.context.showNotify({badge: "danger", title: "رخداد خطا", description: "تمام موارد را تکمیل کنید" });
        
        self.userReferrerService.sendInvitation(state.entity).then(function (response) {
            if (response.status === 200 ||response.status === 204){
                self.setState({entity: { phoneNumber: '', fullName: '' } });
                self.props.reload()
                self.context.showNotify({ badge: "success", title: "موفق", description: "دعوتنامه با موفقیت برای دوست شما ارسال شد" })
            } else {
                return self.context.showNotify({badge: "danger", title: "ناموفق", description: "شماره وارد شده از قبل در این پنل عضو شده است" });
            }
        }).catch(() =>{
                return self.context.showNotify({badge: "danger", title: "ناموفق", description: "شماره وارد شده از قبل در این پنل عضو شده است" });
        });
    }
    
    openQrInviteFriendsCodeModal = () => {
        this.qrCodeGenerate.current?.openQrInviteFriendsCodeModal();
    }

    render(): React.ReactNode {
        let { entity } = this.state;
        return (<>
            <div className="tk-card user-invite-form-area">
                <div className="card-icon">
                    <span className="qr-img">
                        <i className="mdi mdi-qrcode" onClick={this.openQrInviteFriendsCodeModal}></i>
                    </span>
                </div>
                <div className="card-title">
                    <label> جهت دعوت از دوستان خود شماره همراه مورد نظر را وارد نمایید </label>
                </div>
                <div className="col-12">
                    <label className="placholder">نام و نام خانوادگی</label>
                    <input type={"text"} className="form-control" value={entity.fullName} onChange={e => this.setState((prevState) => {
                        return { entity: { ...prevState.entity, fullName: e.target.value } }
                    })} placeholder="نام و نام خانوادگی" />
                </div>
                <div className="col-12">
                    <label className="placholder">شماره همراه</label>
                    <input type={"text"} className="form-control" inputMode="numeric" value={entity.phoneNumber} onChange={e => this.setState((prevState) => {
                        return { entity: { ...prevState.entity, phoneNumber: e.target.value } }
                    })} placeholder="شماره همراه" />
                </div>

                <div className="col-12 continent tk-padding-top tk-padding-bottom">
                    <input type="submit" onClick={this.sendMessage} className="btn btn-primary" value="ارسال دعوت نامه" />
                </div>
            </div>

            <QrInviteFriendsCode ref={this.qrCodeGenerate}/>
        </>);
    }
}